import { SYS_PERMISSIONS } from '@/constants.js';

const state = {
  id: null,
  hash: null,
  name: null,
  icon_url: null,
  features: [],
  members: [],
  default_role_id: null,
  subscription_seats: null,
  monthly_subscription_seats: null,
  yearly_subscription_seats: null,
  current_subscription: null,
  current_subscription_plan: null,
  is_stripe_customer: false,
};

const getters = {
  getId(state) {
    return state.id;
  },
  getHash(state) {
    return state.hash;
  },
  getName(state) {
    return state.name;
  },
  getFeatures(state) {
    return state.features;
  },
  getFeature(state) {
    return key => state.features[key];
  },
  getTotalBillableUsers(state) {
    return state.total_billable_users;
  },
  getCurrentSubscription(state) {
    return state.current_subscription;
  },
  getCurrentSubscriptionPlan(state) {
    return state.current_subscription_plan;
  },
  getIconUrl(state) {
    return state.icon_url;
  },
  getMembers(state) {
    return state.members;
  },
  getDefaultRoleId(state) {
    return state.default_role_id;
  },
  getSubscriptionsSeats(state) {
    return state.subscriptions_seats;
  },
  getMonthlySubscriptionSeats(state) {
    return state.monthly_subscription_seats;
  },
  getYearlySubscriptionSeats(state) {
    return state.yearly_subscription_seats;
  },
  getWorkspace(state) {
    return state;
  },
  getIsPastDue(state) {
    return (
      state.current_subscription &&
      state.current_subscription.stripe_status === 'past_due'
    );
  },
  getShowPastDueNotification(state, getters, rootState, rootGetters) {
    return (
      getters.getIsPastDue &&
      rootGetters['permissions/getPermissions']?.includes(
        SYS_PERMISSIONS.SYS_BILLING_MANAGE
      )
    );
  },
  getIsStripeCustomer(state) {
    return state.is_stripe_customer;
  },
};

const actions = {
  /**
   * Set the workspace to the given value if not null, else reset the state
   */
  setWorkspace(context, { value }) {
    if (context.state.id !== null && context.state.id !== value.id) {
      context.dispatch(
        'application/channels/leaveWorkspaceUpdateChannel',
        { id: context.state.id },
        { root: true }
      );
    }

    context.commit('setWorkspace', {
      value: value || {
        id: null,
        hash: null,
        name: null,
        icon_url: null,
        features: [],
        total_billable_users: 0,
        current_subscription: null,
        current_subscription_plan: null,
        members: [],
        default_role_id: null,
        subscription_seats: null,
        monthly_subscription_seats: null,
        yearly_subscription_seats: null,
        is_stripe_customer: false,
      },
    });

    if (value.id !== null) {
      context.dispatch(
        'application/channels/startWorkspaceUpdateChannel',
        { id: value.id },
        { root: true }
      );
    }

    return context.getters.getWorkspace;
  },
};

const mutations = {
  /**
   * Set the workspace to the given value
   */
  setWorkspace(state, { value }) {
    if (state.id !== value.id) {
      // Use if so we do not trigger query invalidation
      state.id = value.id;
    }
    if (state.hash !== value.hash) {
      state.hash = value.hash;
    }
    state.name = value.name;
    state.icon_url = value.icon_url;
    state.features = value.features;
    state.total_billable_users = value.total_billable_users;
    state.current_subscription = value.current_subscription;
    state.current_subscription_plan = value.current_subscription_plan;
    state.members = value.members;
    state.default_role_id = value.default_role_id;
    state.subscriptions_seats = value.subscriptions_seats;
    state.monthly_subscription_seats = value.monthly_subscription_seats;
    state.yearly_subscription_seats = value.yearly_subscription_seats;
    state.is_stripe_customer = value.is_stripe_customer;
  },
};

const module = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};

export default module;
